import React from "react";
import ReportPage from "./ReportPage";
export default function Report() { return <ReportPage reportKey="sales-items" />; }
